import { generateDetailedExplanation, generateFailedPrequaliReason } from "../utils/generateSummaries";
import { DecisionSummaryCardProps } from "./decision-summary-card"
import { useParams } from "@tanstack/react-router"
import { useGetHiringcampaignsId } from '../../../../openapi/api/endpoints/default/default';
import { LoadingSpinner } from "@/components/ui/loadingSpinner";


const CandidateAnalysis = ({ candidate, decision, summary, reasoning }:DecisionSummaryCardProps) => {
  const hiringCampaignId=useParams({
    from:"/allCampaigns/$hiringCampaignId/summary/$applicationId",
    select:(params)=>params.hiringCampaignId as string
  })
  const {data:hiringCampaign, isLoading}=useGetHiringcampaignsId(hiringCampaignId)

  const mainSkill=hiringCampaign?.mainSkills


  console.log({hcdata:hiringCampaign})
  const isQualified = candidate?.isQualified && summary;
  if( !mainSkill || !hiringCampaign || isLoading){
    return <LoadingSpinner/>
  }

  return (
    <div>
      {isQualified ? (
        <div className="space-y-4">
          {generateDetailedExplanation(decision, summary, mainSkill)}
        </div>
      ) : (
        <div className="text-sm text-gray-600">
          {generateFailedPrequaliReason(reasoning)}
        </div>
      )}
    </div>
  );
};

export default CandidateAnalysis;
